import React from "react";
import { formatTime, calculateFTEVacationDays } from "../utils/timeFormatting";

interface StatsCardsProps {
  totalOvertime: number;
  remainingVacation: number;
  plannedVacation: number;
}

const StatsCards: React.FC<StatsCardsProps> = ({ totalOvertime, remainingVacation, plannedVacation }) => {
  const freeVacation = remainingVacation - plannedVacation;

  return (
    <div className="stats-cards-compact">
      <div className="stat-card-compact">
        <div className="stat-label">Überstunden gesamt</div>
        <div className="stat-value-compact">{formatTime(totalOvertime)}</div>
        <div className="stat-subtext">{calculateFTEVacationDays(totalOvertime)} FTE</div>
      </div>
      <div className="stat-card-compact">
        <div className="stat-label">Verbleibender Urlaub</div>
        <div className="stat-value-compact">{formatTime(remainingVacation)}</div>
        <div className="stat-subtext">{calculateFTEVacationDays(remainingVacation)} FTE</div>
      </div>
      <div className="stat-card-compact">
        <div className="stat-label">Eingeplant (genehmigt)</div>
        <div className="stat-value-compact">{formatTime(plannedVacation)}</div>
        <div className="stat-subtext">{calculateFTEVacationDays(plannedVacation)} FTE</div>
      </div>
      <div className="stat-card-compact">
        <div className="stat-label">Frei verfügbar</div>
        <div className="stat-value-compact">{formatTime(freeVacation)}</div>
        <div className="stat-subtext">{calculateFTEVacationDays(freeVacation)} FTE</div>
      </div>
    </div>
  );
};

export default StatsCards;
